//changed due to package upgrade
import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  Stack,
  useMediaQuery,
  alpha,
} from '@mui/material';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import IntlMessages from '@projectK/helpers/IntlMessages';

const customScrollbarStyle = {
  // Define the styles for the scrollbar
  '&::-webkit-scrollbar': {
    width: '8px',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#44444461', // Lighter black color
    borderRadius: '8px', // Curved border
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#666', // Lighter black color on hover
  },
};
const getColor = (data) => {
  if (!data?.status_code) return '#000000'; // default

  if (data.status_code >= 400) {
    return '#f44336'; // red for expired/error
  } else if (data.status_code >= 200) {
    return '#21f36bff'; // blue for success/active
  }

  return '#000000';
};
const formatMetadata = (metadata) => {
  let parsed;
  let error = null;

  if (!metadata) {
    error = 'No metadata';
  } else {
    try {
      parsed = typeof metadata === 'string' ? JSON.parse(metadata) : metadata;
    } catch (e) {
      error = 'Invalid metadata format';
    }
  }

  if (error) {
    return <div style={{ color: 'gray', fontStyle: 'italic' }}>{error}</div>;
  }

  const body = parsed.body || {};
  const query = parsed.query || {};
  const deletedInfo = parsed.deletedInfo || null;

  const formatObject = (obj) =>
    Object.entries(obj)
      .map(
        ([key, val]) =>
          `${key}: ${typeof val === 'object' ? JSON.stringify(val) : val}`,
      )
      .join(', ') || 'empty';

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div>
        Body → {'{ '}
        {formatObject(body)}
        {' }'}
      </div>
      <div>
        Query → {'{ '}
        {formatObject(query)}
        {' }'}
      </div>
      {deletedInfo && <div>Details → {deletedInfo}</div>}
    </div>
  );
};

const ViewAuditLog = ({
  isOpen,
  onClose,
  emailtemplateData,
  localDate,
  models,
}) => {
  const companyTheme = CompanyTheme();
  const isMobile = useMediaQuery('(max-width: 755px)');

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        className='p-popup'
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 4,
          minWidth: 300,
          // width: 800,
          maxHeight: 'calc(100vh - 200px)',
          overflow: 'auto',
          overflowWrap: 'break-word',
          ...customScrollbarStyle,
        }}
      >
        <Formik>
          <Form>
            <Typography variant='h4' color={companyTheme.primary.main}>
              View Audit Log
            </Typography>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>User Name</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                    {' '}
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {emailtemplateData.userName || '-'}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>User Role</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                    {' '}
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {emailtemplateData.user_role || '-'}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Actual User</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {emailtemplateData.created_userName || '-'}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Actual User Role</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {emailtemplateData.actual_role || '-'}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Model</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {models?.find(
                            (m) => m.key === emailtemplateData.model,
                          )?.label || emailtemplateData.model}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Created Data Time</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {localDate}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Action Type</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 6 }} sx={{ my: 2 }}>
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{ textTransform: 'capitalize' }}
                          className='wordbreak'
                        >
                          {emailtemplateData.action}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='left'>
                        <span>Message</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 1 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box display='flex' justifyContent='center'>
                        <span>:</span>
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 7 }} sx={{ my: 2 }}>
                    {' '}
                    <Typography variant='h4' sx={{ fontWeight: 'normal' }}>
                      <Box display='flex' justifyContent='flex-start'>
                        <span
                          style={{
                            textTransform: 'capitalize',
                            color: getColor(emailtemplateData),
                          }}
                          className='wordbreak'
                        >
                          {emailtemplateData.message || '-'}
                        </span>
                      </Box>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ xs: 12 }} sx={{ ml: 4 }}>
                <Stack spacing={1}>
                  <Grid size={{ xs: 4 }} sx={{ my: 2 }}>
                    <Typography variant='h4'>
                      <Box
                        display='flex'
                        justifyContent='left'
                        sx={{ marginBottom: 3 }}
                      >
                        <span>Content</span>
                      </Box>
                    </Typography>
                  </Grid>

                  <Typography
                    variant='h4'
                    sx={{
                      fontWeight: 'normal',
                      wordBreak: 'break-all',
                      whiteSpace: 'pre-line',
                    }}
                  >
                    <Box display='flex' justifyContent='flex-start'>
                      {formatMetadata(emailtemplateData.metadata)}
                    </Box>
                  </Typography>
                </Stack>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <Box display='flex' justifyContent='flex-end'>
                  <Button
                    variant='outlined'
                    sx={{
                      borderColor: companyTheme
                        ? companyTheme.primary.main
                        : '#2196f3',
                      '&:hover': {
                        borderColor: companyTheme
                          ? alpha(companyTheme.primary.main, 0.8)
                          : alpha('#2196f3', 0.8),
                      },
                      color: companyTheme
                        ? companyTheme.primary.main
                        : '#2196f3',
                    }}
                    onClick={onClose}
                    size={isMobile ? 'small' : 'medium'}
                  >
                    <IntlMessages id='common.cancel' />
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Box>
    </Modal>
  );
};

export default ViewAuditLog;

ViewAuditLog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  emailtemplateData: PropTypes.object.isRequired,
  localDate: PropTypes.any,
  models: PropTypes.array,
};
